import {
  animate,
  group,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { createAnimation } from '@ionic/angular';

export const navTransitionFade = (baseEl, opts) => {
  const enteringAnimation = createAnimation()
    .addElement(opts.enteringEl)
    .fromTo('opacity', 0, 1)
    .duration(100);

  const animation = createAnimation().addAnimation(enteringAnimation);
  return animation;
};

export const pageTransitionFade = trigger('pageTransitionFade', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('100ms ease-out', style({ opacity: 1 })),
  ]),
]);

export const viewTransitionFade = trigger('viewTransitionFade', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('250ms ease-out', style({ opacity: 1 })),
  ]),
]);

export const webInfoCardFade = trigger('webInfoCardFade', [
  transition(':enter', [
    style({ height: '0px', opacity: 0 }),
    group([
      animate('100ms ease-out', style({ height: '240px' })),
      animate('350ms ease-out', style({ opacity: 1 })),
    ]),
  ]),
  transition(':leave', [
    style({ height: '240px', opacity: 1 }),
    animate('100ms ease-out', style({ height: '0px', opacity: 0 })),
  ]),
]);

export const webDocumentFileListCardFade = trigger(
  'webDocumentFileListCardFade',
  [
    transition('void => up', [
      style({ transform: 'translateY(-495px)' }),
      animate('200ms', style({ transform: 'translateY(0px)' })),
    ]),
    transition('void => down', [
      style({ transform: 'translateY(495px)' }),
      animate('200ms', style({ transform: 'translateY(0px)' })),
    ]),
    transition('void => none', [
      style({ opacity: '0' }),
      animate('250ms ease-out', style({ opacity: '1' })),
    ]),

    transition('up => void', [
      style({ opacity: '1' }),
      animate('100ms', style({ opacity: '0' })),
    ]),
    transition('down => void', [
      style({ opacity: '1' }),
      animate('100ms', style({ opacity: '0' })),
    ]),
    transition('none => void', [
      style({ opacity: '1' }),
      animate('100ms', style({ opacity: '0' })),
    ]),
  ]
);

export const webKpoListCardFade = trigger('webKpoListCardFade', [
  transition('void => up', [
    style({ transform: 'translateY(-495px)' }),
    animate('200ms', style({ transform: 'translateY(0px)' })),
  ]),
  transition('void => down', [
    style({ transform: 'translateY(495px)' }),
    animate('200ms', style({ transform: 'translateY(0px)' })),
  ]),

  transition('up => void', [
    style({ opacity: '1' }),
    animate('100ms', style({ opacity: '0' })),
  ]),
  transition('down => void', [
    style({ opacity: '1' }),
    animate('100ms', style({ opacity: '0' })),
  ]),
  // transition('none => void', [
  //   style({ opacity: '1' }),
  //   animate('1000ms', style({ opacity: '0' })),
  // ]),
]);
